<template>
    <div v-if="project">
        <div class="columns toolbar-box">
            <div class="column is-4">
                <h1 class="title is-3 between-center">
                    <span>{{ project.full_name }}</span>
                </h1>
            </div>
            <div class="column is-8 action-box">
                <div class="field is-grouped is-grouped-right is-flex-wrap">
                    <p class="control">
                        <router-link :to="backlink({name: 'projects.index'})" class="button is-default" >Back</router-link>
                    </p>
                    <p class="control">
                        <a @click.prevent="openGlobalTimelog({project_id: project.id})" class="button is-primary">Log Time</a>
                    </p>
                    <p class="control">
                        <a @click.prevent="confirmCustomDelete(project, 'projects.index', 'Deleting Project', 'Do you want to delete this project? this action cannot be undone')" class="button is-danger">Delete Project</a>
                    </p>
                    <p class="control">
                        <a v-if="isFollowed(project.id)" @click.prevent="unfollow(project)" class="button is-info">Unfollow</a>
                        <a v-else @click.prevent="follow(project)" class="button is-info">Follow</a>
                    </p>
                    <p class="control">
                        <router-link :to="{ name: 'projects.edit', params: { slug: $route.params.slug } }" class="button is-info">Edit</router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns is-multiline">
            <div class="projectinfo-column column is-12 is-12-tablet is-3-desktop is-2-fullhd">
                <div class="columns is-multiline">
                    <div class="column is-4-tablet is-12-desktop is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus">
                        <b-panel :collapsible="true">
                          <template #header>
                            <div style="text-align: center">
                              <strong>Info</strong>
                            </div>
                          </template>
                            <div class="content full-width">
                                <p class="between-center"><strong>Company:</strong> <span class="has-text-right">{{ $filters.valueOrDefault(project.company_name) }}</span></p>
                                <p class="between-center"><strong>Contact:</strong> <span class="has-text-right">{{ $filters.valueOrDefault(project.contact_name) }}</span></p>
                                <p class="between-center"><strong>Building #:</strong> <span class="has-text-right">{{ project.building }}</span></p>
                                <p class="between-center"><strong>Street:</strong> <span class="has-text-right">{{ project.street }}</span></p>
                                <p class="between-center"><strong>Borough:</strong> <span class="has-text-right">{{ boroughNameById(project.borough) }}</span></p>
                                <p class="between-center"><strong>Floor:</strong> <span class="has-text-right">{{ project.floor_number }}</span></p>
                                <p class="between-center"><strong>Status:</strong> <span class="has-text-right">{{ statusNameById(project.status) }}</span></p>
                                <p class="between-center"><strong>Project Type:</strong> <span class="has-text-right">{{ projectTypeNameById(project.project_type) }}</span></p>
                                <p class="between-center"><strong>Created at:</strong> <span class="has-text-right">{{  $filters.valueOrDefault($filters.datetime(project.created_at), '-') }}</span></p>
                                <p class="between-center"><strong>Project Manager:</strong> <span class="has-text-right">{{ $filters.valueOrDefault(userNameById(project.assigned_to) ) }}</span></p>
                                <p class="between-center"><strong>Senior PM:</strong> <span class="has-text-right">{{ $filters.valueOrDefault(userNameById(project.senior_pm_id) ) }}</span></p>
                            </div>
                        </b-panel>
                    </div>
                    <div class="column is-4-tablet is-12-desktop is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus">
                        <b-panel :collapsible="true">
                          <template #header>
                            <div style="text-align: center">
                              <strong>Job Cost Summary</strong>
                            </div>
                          </template>
                            <div class="content full-width">
                                <p class="between-center"><strong>Contract Price:</strong> <span class="has-text-right">{{ $filters.currency(contractPrice ) }}</span></p>
                                <p class="between-center"><strong>Change Orders:</strong> <span class="has-text-right">{{ $filters.currency(changeOrdersPrice ) }}</span></p>
                                <p class="between-center"><strong>Sub total:</strong>{{ $filters.currency(budget ) }}</p>
                                <p class="between-center"><strong>Total Hours:</strong> <span class="has-text-right">{{ $filters.valueOrDefault(totalHours, '0') }}</span></p>
                                <p class="between-center"><strong>Total Hours Cost:</strong> <span class="has-text-right">{{ $filters.currency($filters.valueOrDefault(totalHoursPrice, '0') ) }}</span></p>
                                <p class="between-center"><strong>Difference:</strong> <span class="has-text-right">{{ $filters.currency(diff ) }}</span></p>
                                <p class="between-center"><strong>Expenses:</strong> <span class="has-text-right">{{ $filters.currency(expenses ) }}</span></p>
                            </div>
                        </b-panel>
                    </div>
                    <div class="column is-4-tablet is-12-desktop is-4-fullhd is-12-hd is-12-hd-wide is-12-hd-plus">
                        <b-panel v-if="latestNote" :collapsible="true">
                          <template #header>
                            <strong>Most recent note</strong>
                          </template>
                            <div class="break-word content full-width">
                                <p class="between-center"><strong>Author:</strong> <span class="has-text-right">{{ userNameById(latestNote.user_id) }}</span></p>
                                <p class="between-center"><strong>Created at:</strong> <span class="has-text-right">{{ $filters.date(latestNote.created_at) }}</span></p>
                                <div v-html="latestNote.message"></div>
                            </div>
                        </b-panel>
                    </div>
                </div>

                <router-link :to="{ name: 'change-orders.create', query: {project_id: currentProjectId}}" class="button is-dark is-fullwidth block">Create Change Order</router-link>
            </div>
            <div class="column is-12 is-12-tablet is-9-desktop is-10-fullhd project-tabs">
                <o-tabs :model-value="activeTab" @update:model-value="changeTab" type="is-boxed is-hd-wide project-tabs">
                    <o-tab-item :value="0" label="Services" ></o-tab-item>
                    <o-tab-item :value="1" label="Emails" ></o-tab-item>
                    <o-tab-item :value="2" label="Milestones" :disabled="hasInvalidEstimatedDates"></o-tab-item>
                    <o-tab-item :value="3" label="Activities" :disabled="hasInvalidEstimatedDates" ></o-tab-item>
                    <o-tab-item :value="4" label="Contacts" :disabled="hasInvalidEstimatedDates" ></o-tab-item>
                    <o-tab-item :value="5" label="Applications" :disabled="hasInvalidEstimatedDates" ></o-tab-item>
                    <o-tab-item :value="6" label="Notes" :disabled="hasInvalidEstimatedDates" ></o-tab-item>
                    <o-tab-item :value="7" label="Documents" :disabled="hasInvalidEstimatedDates" ></o-tab-item>
                    <o-tab-item :value="8" label="Time Logs"  :disabled="hasInvalidEstimatedDates"></o-tab-item>
                    <o-tab-item :value="9" label="Change Orders"  :disabled="hasInvalidEstimatedDates"></o-tab-item>
                    <o-tab-item :value="10" label="Job Costing"  :disabled="hasInvalidEstimatedDates"></o-tab-item>
                </o-tabs >

                <router-view @tab-changed="changeRoute" />
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isViewTimeLogModalActive" has-modal-card>
            <view-time-log-modal :time-log="currentTimeLog"/>
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from './../../mixins/Table'
    import HasBacklink from './../../mixins/Backlink'

    export default {
        mixins: [Table, HasBacklink],

        data () {
            return {
                isViewContactModalActive: false,
                isViewTimeLogModalActive: false,
                isTimeLogModalActive: false,
                currentContact: null,
                currentTimeLog: null,
                totalHoursPrice: 0,
                project: null,
                totalHours: 0,
                activeTab: 0,
            }
        },

        computed: {
            ...mapGetters([
                'projectServicesPaymentsByProjectId',
                'projectServicesExceptOfOptionalByProjectId',
                'changeOrdersPriceByProjectId',
                'contractPriceByProjectId',
                'latestNoteByProjectId',
                'expensesByProjectId',
                'currentProjectId',
                'boroughNameById',
                'projectNameById',
                'projectTypeNameById',
                'userNameById',
                'isFollowed',
                'currentUserId'
            ]),
            projectServices() {
                return this.projectServicesExceptOfOptionalByProjectId(this.currentProjectId);
            },
            invalidEstimatedDates() {
                return this.projectServices.filter(p => this.isEstimatedBillDateInvalid(p));
            },
            hasInvalidEstimatedDates() {
                return this.project.assigned_to == this.currentUserId && this.invalidEstimatedDates.length > 0;
            },
            latestNote() {
                return this.latestNoteByProjectId(this.currentProjectId);
            },

            contractPrice() {
                return this.contractPriceByProjectId(this.currentProjectId)
            },

            changeOrdersPrice() {
                return this.changeOrdersPriceByProjectId(this.currentProjectId)
            },

            expenses() {
                return this.expensesByProjectId(this.currentProjectId)
            },

            budget() {
                return this.contractPrice + this.changeOrdersPriceByProjectId(this.currentProjectId)
            },

            diff() {
                return this.budget - this.totalHoursPrice
            }
        },

        mounted () {
            let id = parseInt(this.$route.params.slug)

            this.openInitialTab()
            this.setCurrentProjectId(id)
            this.fetchProjectById(id)
                .then(res => {
                    this.project = res.data.data;
                    if(this.hasInvalidEstimatedDates) {
                        this.changeTab(0);
                    }
            });
            this.fetchTotalHoursPriceByProjectId(id)
                .then(res => {
                    this.totalHoursPrice = res.data.data.total_hours_price
                    this.totalHours = res.data.data.total_hours
                    return res
                });
        },

        methods: {
            ...mapActions([
                'fetchTotalHoursPriceByProjectId',
                'updateFollowedProject',
                'setCurrentProjectId',
                'fetchProjectById',
                'openGlobalTimelog'
            ]),

            ...mapActions({
                removeItem: 'removeProject'
            }),

            follow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('You are following this project now')
                })
            },

            unfollow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('You are not following this project anymore')
                })
            },

            changeTab(tabIndex) {

                this.activeTab = tabIndex;
                let subRouteName = '';

                switch (tabIndex) {
                    case 0:
                        subRouteName = 'services'
                        break
                    case 1:
                        subRouteName = 'emails'
                        break
                    case 2:
                        subRouteName = 'activities'
                        break
                    case 3:
                        subRouteName = 'tasks'
                        break
                    case 4:
                        subRouteName = 'contacts'
                        break
                    case 5:
                        subRouteName = 'applications'
                        break
                    case 6:
                        subRouteName = 'notes'
                        break
                    case 7:
                        subRouteName = 'documents'
                        break
                    case 8:
                        subRouteName = 'time-logs'
                        break
                    case 9:
                        subRouteName = 'change-orders'
                        break
                    case 10:
                        subRouteName = 'job-costing'
                        break
                }

                this.$router.push({ name: `projects.show.${subRouteName}` })
            },

            changeRoute(route) {
                if (typeof route === 'string') {
                    return this.openInitialTab(route)
                }

                this.$router.push(route)
                this.openInitialTab(route.name)
            },

            openInitialTab(routeName = null) {
                switch (routeName || this.$route.name) {
                    case 'projects.show':
                    case 'projects.show.services':
                        this.activeTab = 0
                        break
                    case 'projects.show.emails':
                        this.activeTab = 1
                        break
                    case 'projects.show.activities':
                        this.activeTab = 2
                        break
                    case 'projects.show.tasks':
                        this.activeTab = 3
                        break
                    case 'projects.show.contacts':
                        this.activeTab = 4
                        break
                    case 'projects.show.applications':
                    case 'projects.show.applications.tab':
                    case 'projects.show.applications.type':
                        this.activeTab = 5
                        break
                    case 'projects.show.notes':
                        this.activeTab = 6
                        break
                    case 'projects.show.documents':
                        this.activeTab = 7
                        break
                    case 'projects.show.time-logs':
                        this.activeTab = 8
                        break
                    case 'projects.show.change-orders':
                        this.activeTab = 9
                        break
                    case 'projects.show.job-costing':
                        this.activeTab = 10
                        break
                }
            },
            isEstimatedBillDateInvalid(projectService) {
                return projectService.status === 'approved' && (!projectService.estimated_bill_date || ( new Date(`${projectService.estimated_bill_date} `) < new Date(new Date().toLocaleDateString())))
            }
        },
        watch: {
            $route(to, from) {
                if(/^projects(?:\.[a-z\.-]*)?$/g.test(to.name)){
                    this.changeRoute(to.name)
                }
            },
        },
    }
</script>
<style lang="sass" scoped>
div.projectinfo-column
  .content
    .between-center
      align-items: center
      display: flex
      flex-direction: column
      @media screen and (min-width: 768px)
        strong
          padding-right: 12px
        span
          word-break: break-word
</style>
